module.exports = __webpack_public_path__ + "static/media/whats-new.b3417ba6.md";